import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';
import { PageHeader } from '@/components/ui/PageHeader';

/**
 * Stands in for a module that has not shipped yet.
 *
 * One component rather than thirty near-identical page files: the route table already knows the
 * title key, so a placeholder carries no information the navigation config does not already hold.
 */
export function PlaceholderPage({ titleKey }: { titleKey: string }) {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <PageHeader title={t(titleKey)} subtitle={t('common.notAvailableYet')} />

      <Card>
        <EmptyState
          icon={Construction}
          title={t('common.comingSoon')}
          description={t('common.placeholderHint')}
        />
      </Card>
    </div>
  );
}
